export const LOGO_POSITION_OPTIONS = [
  { value: "top-left", label: "Top left" },
  { value: "top-right", label: "Top right" },
  { value: "bottom-left", label: "Bottom left" },
  { value: "bottom-right", label: "Bottom right" }
];

export const LOGO_SIZE_OPTIONS = [
  { value: "small", label: "Small" },
  { value: "mid", label: "Medium" },
  { value: "big", label: "Big" }
];
